import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'

export default [{
	path: routeList.PAYMENTS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
},
{
	path: routeList.PAYMENTS_BAI_PAGA_PATH,
	name: routeList.PAYMENTS_BAI_PAGA_NAME,
	props: true,
	component: () => import('@/views/payments/BAIPaga')
},
/* ***********************************************
*                    BATCHFILE                   *
*********************************************** */
{
	path: routeList.PAYMENTS_BATCHFILE_PATH,
	name: routeList.PAYMENTS_BATCHFILE_NAME,
	component: () => import('@/views/payments/batchfile/SalariesAndSupplies')
},
/* ****************** Consult ***************** */
{
	path: routeList.PAYMENTS_BATCHFILE_CONSULT_SALARIES_AND_SUPPLIES_PATH,
	name: routeList.PAYMENTS_BATCHFILE_CONSULT_SALARIES_AND_SUPPLIES_NAME,
	component: () => import('@/views/payments/batchfile/SalariesAndSupplies')
}, {
	path: routeList.PAYMENTS_BATCHFILE_CONSULT_STATE_PATH,
	name: routeList.PAYMENTS_BATCHFILE_CONSULT_STATE_NAME,
	component: () => import('@/views/payments/batchfile/State')
},
/* ****************** New Payment ***************** */
{
	path: routeList.PAYMENTS_BATCHFILE_NEW_PAYMENT_PATH,
	name: routeList.PAYMENTS_BATCHFILE_NEW_PAYMENT_NAME,
	component: () => import('@/views/ThirdLevelMenu')
},
{
	path: routeList.PAYMENTS_BATCHFILE_NEW_PAYMENT_SALARIES_AND_SUPPLIES_PATH,
	name: routeList.PAYMENTS_BATCHFILE_NEW_PAYMENT_SALARIES_AND_SUPPLIES_NAME,
	component: () => import('@/views/payments/batchfile/newPayment/SalariesAndSupplies')
}, {
	path: routeList.PAYMENTS_BATCHFILE_NEW_PAYMENT_STATE_PATH,
	name: routeList.PAYMENTS_BATCHFILE_NEW_PAYMENT_STATE_NAME,
	component: () => import('@/views/payments/batchfile/newPayment/State')
},
/* ***********************************************
*                     SERVICES                   *
*********************************************** */
{
	path: routeList.PAYMENTS_SERVICES_PATH,
	name: routeList.PAYMENTS_SERVICES_NAME,
	props: true,
	component: () => import('@/views/payments/Services')
},
{
	path: routeList.PAYMENTS_SISP_RECHARGE_PATH,
	name: routeList.PAYMENTS_SISP_RECHARGE_NAME,
	component: () => import('@/views/payments/flows/Recharge'),
	props: true,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.PAYMENTS_SERVICES_NAME)
	}
},
/* ***********************************************
*                     REFERENCE                   *
*********************************************** */
{
	path: routeList.PAYMENTS_SISP_REFERENCE_PATH,
	name: routeList.PAYMENTS_SISP_REFERENCE_NAME,
	props: true,
	component: () => import('@/views/payments/flows/Reference')
},
/* ***********************************************
*                     REQUESTS                   *
*********************************************** */
{
	path: routeList.PAYMENTS_REQUESTS_PATH,
	name: routeList.PAYMENTS_REQUESTS_NAME,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.PAYMENTS_REQUESTS_BAI_PAGA_PATH,
	name: routeList.PAYMENTS_REQUESTS_BAI_PAGA_NAME,
	component: () => import('@/views/payments/requests/BaiPaga')
}, {
	path: routeList.PAYMENTS_REQUESTS_BAI_PAGA_PAY_PATH,
	name: routeList.PAYMENTS_REQUESTS_BAI_PAGA_PAY_NAME,
	props: true,
	component: () => import('@/views/payments/requests/BaiPagaPay'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.PAYMENTS_REQUESTS_BAI_PAGA_NAME)
	}
}, {
	path: routeList.PAYMENTS_REQUESTS_EKWANZA_PATH,
	name: routeList.PAYMENTS_REQUESTS_EKWANZA_NAME,
	component: () => import('@/views/UnderDevelopment')
}, {
	path: routeList.PAYMENTS_HISTORY_PATH,
	name: routeList.PAYMENTS_HISTORY_NAME,
	component: () => import('@/views/payments/History')
}]
